import { fiatCurrencyExchangeApi } from 'api';
import { DialogProps, PriceChartDialog } from 'components';
import { useMutation } from 'hooks';
import { FiatCurrencyExchange } from 'types';

type Props = DialogProps<FiatCurrencyExchange>;

export const FiatCurrencyExchangePriceChartDialog: React.FC<Props> = (
  props,
) => {
  const fetchMutation = useMutation(fiatCurrencyExchangeApi.getRatesHistory, {
    notifierType: 'none',
  });

  return <PriceChartDialog fetchMutation={fetchMutation} {...props} />;
};
